import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/fonts';
import './styles/global.css';
import './styles/components.css';
import './styles/layout.css';
import './auth/login.css';
import './features/portal/portal.css';
import { App } from './App';

const root = document.getElementById('root');
if (!root) throw new Error('#root が見つかりません');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
